/* gcpx-pdpspot: the "add your initials" spot on a standard case page's main color photos
   (snippets/gcpx-pdpspot.liquid, owner 4 Oct 2026).

   The spot does not price or save anything itself. A tap or click on it presses the page's own
   "Item Personalization" button ([data-open-personalize-drawer], sections/main-product.liquid), so
   the existing drawer (assets/personalize-drawer.js) opens exactly as it does from that button and
   stays the one place that takes the initials, picks the fee tier and adds the cart lines.

   The spot then follows the drawer:
     personalization:added   (this product)  -> the initials show in gold on every main photo,
                                                the note goes, the button's name becomes "Edit"
     personalization:removed                 -> back to the note (also fired after the case and its
                                                fee went to the cart)

   Gallery: a press that turns into a swipe is not a tap (the slider keeps it), and neither a tap nor a
   swipe reaches the slide underneath (the gallery opens its zoom on a click anywhere in an image slide;
   Oct 2026: a desktop drag that ended on the spot could open it). */
(function () {
  if (window.__gcpxPs) return;
  window.__gcpxPs = 1;

  var MOVE = 10; /* px: more than this between press and release is a swipe, not a tap */
  var down = null;

  function layers() { return document.querySelectorAll('[data-gcpx-ps]'); }
  function opener() {
    return document.querySelector('.Product__Info [data-open-personalize-drawer]') ||
      document.querySelector('[data-open-personalize-drawer]');
  }
  function pid() {
    var b = opener();
    return b ? String(b.getAttribute('data-product-id') || '') : '';
  }

  /* the layer is the photo's box. The figure wraps the image, so they match; if a theme change ever
     lets them differ, the layer follows the image rather than the figure. */
  function fit(layer) {
    var fig = layer.parentNode;
    var img = fig && fig.querySelector('img');
    if (!img || !img.offsetWidth) return;
    var dx = img.offsetLeft, dy = img.offsetTop, w = img.offsetWidth, h = img.offsetHeight;
    var same = Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(w - fig.clientWidth) < 1 && Math.abs(h - fig.clientHeight) < 1;
    if (same) {
      layer.style.left = layer.style.top = layer.style.width = layer.style.height = '';
    } else {
      layer.style.left = dx + 'px'; layer.style.top = dy + 'px';
      layer.style.width = w + 'px'; layer.style.height = h + 'px';
    }
  }
  function fitAll() { Array.prototype.forEach.call(layers(), fit); }

  function show(ini, stamp) {
    var mx = 5, L = window.GC_FEE_LADDER;
    if (L && L.length) for (var i = 0; i < L.length; i++) if (+L[i].max > mx) mx = +L[i].max;
    ini = String(ini || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, mx);
    Array.prototype.forEach.call(layers(), function (l) {
      var t = l.querySelector('[data-gcpx-ps-text]');
      var b = l.querySelector('[data-gcpx-ps-spot]');
      if (t) t.textContent = ini;
      l.style.setProperty('--gcx-scale', ini.length > 6 ? (6 / ini.length).toFixed(3) : '1');
      l.classList.toggle('has-ini', !!ini);
      if (b) b.setAttribute('aria-label', (ini ? b.getAttribute('data-label-edit') : b.getAttribute('data-label-add')) || '');
      if (stamp && ini) {
        l.classList.remove('is-stamp');
        void l.offsetWidth;
        l.classList.add('is-stamp');
      }
    });
  }

  function onDown(e) {
    var s = e.target.closest && e.target.closest('[data-gcpx-ps-spot]');
    down = s ? { s: s, x: e.clientX, y: e.clientY } : null;
  }
  function onClick(e) {
    var s = e.target.closest && e.target.closest('[data-gcpx-ps-spot]');
    if (!s) return;
    var swiped = down && down.s === s && e.detail !== 0 &&
      (Math.abs(e.clientX - down.x) > MOVE || Math.abs(e.clientY - down.y) > MOVE);
    down = null;
    e.preventDefault();
    e.stopPropagation();
    if (swiped) return; /* the slider had it */
    var b = opener();
    if (b) b.click();
  }

  function boot() {
    if (!layers().length) return;
    /* pointerdown in the capture phase: the slider's own handlers must not hide it from us */
    document.addEventListener('pointerdown', onDown, true);
    /* on the spot itself, in the bubble phase: it runs before the slide's zoom listener and stops it */
    Array.prototype.forEach.call(document.querySelectorAll('[data-gcpx-ps-spot]'), function (s) {
      s.addEventListener('click', onClick);
    });
    document.addEventListener('personalization:added', function (e) {
      var d = (e && e.detail) || {};
      var p = pid();
      if (p && d.productId != null && String(d.productId) !== p) return;
      show(d.initials, true);
    });
    document.addEventListener('personalization:removed', function () { show('', false); });
    /* a personalization already active on this page view (the drawer keeps it in window.currentPersonalization) */
    var cur = window.currentPersonalization;
    if (cur && cur.initials) show(cur.initials, false);

    /* shown only once wired up: a copy of the section fetched into another page (the quick-buy
       drawer on collection pages) has no script behind it, so its spots stay hidden */
    Array.prototype.forEach.call(layers(), function (l) { l.classList.add('is-ready'); });
    fitAll();
    window.addEventListener('load', fitAll);
    window.addEventListener('resize', fitAll, { passive: true });
    Array.prototype.forEach.call(layers(), function (l) {
      var img = l.parentNode && l.parentNode.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', function () { fit(l); }, { once: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
